<template>

	<div v-if='Debug.Is_enabled()' id='debug_bar_toggle' @click='_Toggle( $event )' :class='_status'><i class='fa fa-chevron-left'></i></div>
	<div v-if='Debug.Is_enabled()' id='debug_bar_clear' title='Clear all logs' @click='_Clear_all'><i class='fa-regular fa-trash-can'></i></div>

	<div v-if='Debug.Is_enabled()' id='debug_bar' :class='_status'>

		<DebugSection title='Navigation'>

			<DebugFlyout>

				<DebugULMenu>

					<ul>
						<li><router-link :to='{ name: "Login" }'>Login</router-link></li>
						<li><router-link :to='{ name: "Main" }'>Main</router-link></li>
						<li><a href='/404'>404</a></li>
					</ul>

				</DebugULMenu>

			</DebugFlyout>

		</DebugSection>

		<DebugSection title='Service'>

			<DebugFlyout label='Performance' :counter='Debug.Service.Performance.Get().length'>

				<DebugTable :items='Debug.Service.Performance.Get()' :columns='[
					{ label: "Time", field: "datetime", type: "datetime" },
					{ label: "Endpoint", field: "endpoint" },
					{ label: "Duration", field: "duration", suffix: "s" }
					]' />

				<template #actions>
					<DebugFlyoutAction title='Clear'
						@click='Debug.Service.Performance.Clear'><i class='fa-regular fa-trash-can' title='Clear'></i></DebugFlyoutAction>
				</template>

			</DebugFlyout>

			<DebugFlyout label='Errors' :counter='Debug.Service.Errors.Get().length'>

				<DebugTable :items='Debug.Service.Errors.Get()' :columns='[
					{ label: "Time", field: "datetime", type: "datetime" },
					{ label: "Type", field: "type" },
					{ label: "Code", field: "code" },
					{ label: "Message", field: "message", type: "clamp" }
					]' />

				<template #actions>
					<DebugFlyoutAction title='Clear'
						@click='Debug.Service.Errors.Clear'><i class='fa-regular fa-trash-can' title='Clear'></i></DebugFlyoutAction>
				</template>

			</DebugFlyout>

		</DebugSection>

		<DebugSection title='Security'>

			<DebugFlyout label='Token' :counter='Debug.Security.Token.Get().length'>

				<DebugTable :items='Debug.Security.Token.Get()' :columns='[
					{ label: "Time", field: "datetime", type: "datetime" },
					{ label: "Operation", field: "operation" },
					{ label: "Result", field: "result", type: "clamp" }
					]' />

				<template #actions>
					<DebugFlyoutAction title='Clear'
						@click='Debug.Security.Token.Clear'><i class='fa-regular fa-trash-can' title='Clear'></i></DebugFlyoutAction>
				</template>

			</DebugFlyout>

			<DebugFlyout label='User' :counter='Debug.Security.User.Get().length'>

				<DebugTable :items='Debug.Security.User.Get()' :columns='[
					{ label: "Time", field: "datetime", type: "datetime" },
					{ label: "Operation", field: "operation" },
					{ label: "Parameters", field: "parameters" },
					{ label: "Result", field: "result", type: "clamp" }
					]' />

				<template #actions>
					<DebugFlyoutAction title='Clear'
						@click='Debug.Security.User.Clear'><i class='fa-regular fa-trash-can' title='Clear'></i></DebugFlyoutAction>
				</template>

			</DebugFlyout>

		</DebugSection>

	</div>

</template>


<script setup>

	import { ref } from 'vue';

	import * as Debug from '@/modules/debug';
	import DebugFlyout from '@/debug/DebugFlyout';
	import DebugSection from '@/debug/DebugSection';
	import DebugTable from '@/debug/DebugTable';
	import DebugULMenu from '@/debug/DebugULMenu';
	import DebugFlyoutAction from '@/debug/DebugFlyoutAction';


	const _status = ref( 'open' );


	function _Toggle ( event )
	{
		if ( _status.value == 'open' )
			_status.value = 'closed';
		else
			_status.value = 'open';
	}


	function _Clear_all ()
	{
		Debug.Service.Performance.Clear();
		Debug.Service.Errors.Clear();

		Debug.Security.Token.Clear();
		Debug.Security.User.Clear();
	}

</script>


<style scoped>

	#debug_bar
	{
		background: #000;
		border-top: 3px solid #c40000;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 1000000;
		width: 100%;
		display: flex;
		padding-left: 30px;
		font-size: 13px;
		transform: translateX(0);
		transition: transform 0.3s;
	}
	#debug_bar.closed
	{
		transform: translateX(-100%);
	}


	#debug_bar_toggle,
	#debug_bar_clear
	{
		color: #fff;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 22px;
		height: 22px;
		font-size: 10px;
		border-radius: 25px;
		overflow: hidden;
		position: fixed;
		left: 3px;
		bottom: 3px;
		z-index: 1000001;
		transition: background 0.3s;
		background: #000;
	}
	#debug_bar_clear
	{
		font-size: 12px;
		left: auto;
		right: 3px;
	}
	#debug_bar_toggle > *:first-child
	{
		transform: rotate(0deg);
		transition: transform 0.3s;
	}
	#debug_bar_toggle:hover,
	#debug_bar_clear:hover
	{
		background: #555;
	}

	#debug_bar_toggle.closed > *:first-child
	{
		transform: rotate(180deg);
	}

</style>